import { incrementTelemetry } from 'core-events/actions';
import { JSX, useCallback, useState } from 'react';
import { SearchFilterContentTypes } from 'search-gateway-client';

import { AudioFileSearch } from '@videoblocks/react-icons';

import AudioFileSearchModal from './AudioFileSearchModal';

type SearchWithAudioButtonProps = {
    contentType: SearchFilterContentTypes;
};

const audioContentTypes: SearchFilterContentTypes[] = [
    SearchFilterContentTypes.All_audio_content_type,
    SearchFilterContentTypes.Music,
    SearchFilterContentTypes.Sound_effects,
];

const SearchWithAudioButton = ({ contentType }: SearchWithAudioButtonProps): JSX.Element | null => {
    const [isModalOpen, _setIsModalOpen] = useState(false);
    const showAudioButton = audioContentTypes.includes(contentType);

    const setIsModalOpen = useCallback((isOpen: boolean) => {
        _setIsModalOpen(isOpen);
        if (isOpen) void incrementTelemetry('search.bysound.click.init');
    }, []);

    if (!showAudioButton) {
        return null;
    }

    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                className="hidden md:flex w-64 whitespace-nowrap overflow-hidden justify-center py-5 bg-yellow-400 rounded-full hover:bg-yellow-500"
            >
                <AudioFileSearch className="w-6 h-6 mr-2" />
                <span className="text-gray-900 font-semibold">Search with Audio Clip</span>
            </button>
            <AudioFileSearchModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};

export default SearchWithAudioButton;
